module.exports = __webpack_public_path__ + "static/img/wx.8db81ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wx.jpg
// module id = WrqV
// module chunks = 1